import { render, staticRenderFns } from "./DsNote.vue?vue&type=template&id=194ace14&scoped=true&"
import script from "./DsNote.vue?vue&type=script&lang=js&"
export * from "./DsNote.vue?vue&type=script&lang=js&"
import style0 from "./DsNote.vue?vue&type=style&index=0&id=194ace14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194ace14",
  null
  
)

export default component.exports